import { toJS } from 'mobx'
import { type ActionItem } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { type ICallingListResponse } from 'entities/AICalling/api/types'
import { ChatbotPath } from 'pages/chatbot/route/chatbotPath'

export const duplicate = (item: ICallingListResponse): ActionItem => {
  return {
    text: 'Duplicate',
    icon: 'copy',
    onAction: () => {
      const safeItem = toJS(item)
      const name = `Copy of ${safeItem.name}`

      uiStore.changeRoute({
        path: ChatbotPath.callingNew(safeItem.template_type),
        options: {
          state: {
            response: { ...safeItem, name, status: 'draft' },
            isDuplicate: true,
          },
        },
      })
    },
  }
}
